import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import MainServices from './components/MainServices';
import WhatWeDo from './components/WhatWeDo';
import Products from './components/Products';
import Services from './components/Services';
import Solutions from './components/Solutions';
import Partners from './components/Partners';
import ImpactStats from './components/ImpactStats';
import CTA from './components/CTA';
import Footer from './components/Footer';
import ContactPage from './components/ContactPage';
import ProductsPage from './components/ProductsPage';
import ServicesPage from './components/ServicesPage';
import SolutionsPage from './components/SolutionsPage';
import { Toaster } from './components/ui/toaster';

const HomePage = () => (
  <>
    <Hero />
    <MainServices />
    <WhatWeDo />
    <Products />
    <Services />
    <Solutions />
    <Partners />
    <ImpactStats />
    <CTA />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/products" element={<ProductsPage />} />
        </Routes>
        <Footer />
        <Toaster />
      </div>
    </BrowserRouter>
  );
}

export default App;